/**
 * Strip HTML to a single-line plain preview (for triage list cells).
 * Handles real tags and escaped markup left as text (e.g. &lt;div&gt;).
 */
export function htmlToPlainPreview(value: string, maxLen = 140): string {
    let text = String(value || '').trim();
    if (!text)
        return '';

    const needsHtmlParsing = /[<>&]/.test(text);

    if (!needsHtmlParsing) {
        text = text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
        if (!maxLen || text.length <= maxLen)
            return text;

        return `${text.slice(0, Math.max(0, maxLen - 1))}…`;
    }

    if (typeof DOMParser !== 'undefined') {
        const doc = new DOMParser().parseFromString(`<div id="yoda-preview">${text}</div>`, 'text/html');
        const root = doc.getElementById('yoda-preview') || doc.body;
        root.querySelectorAll('br').forEach((br) => {
            br.replaceWith(doc.createTextNode(' '));
        });
        text = root.textContent || '';
    }

    // Drop leftover / escaped tags that survived as plain text (e.g. "<div>").
    text = text.replace(/<[^>]*>/g, ' ');

    text = text
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;|&apos;/gi, "'")
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>');

    // Decoding may reintroduce tag-looking sequences once.
    text = text.replace(/<[^>]*>/g, ' ');

    text = text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    if (!maxLen || text.length <= maxLen)
        return text;

    return `${text.slice(0, Math.max(0, maxLen - 1))}…`;
}
